import { NgModule } from '@angular/core';
import { JumbotronModule } from '../../../shared/jumbotron/jumbotron.module';
import { UnitListFeatureComponent } from './feature-units.component';
import { FeatureChargesComponent } from './feature-charges.component';
import { FeaturePaymentsComponent } from './feature-payments.component';
import { FeatureTransactionsComponent } from './feature-transactions.component';
import { FeatureBudgetsComponent } from './feature-budgets.component';
import { RouterModule } from '@angular/router';
import { FeatureBillPayComponent } from './feature-bill-pay.component';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { AddClassOnHoverModule } from '../../../../directives/add-class-on-hover/add-class-on-hover.module';
import { ModalModule } from '../../../shared/modal/modal.module';
import { ChargesService } from '../../../../services/charges/charges.service';
import { IfOnDomModule } from '../../../../directives/if-on-dom.module';
import { ButtonModule } from '../../../shared/button/button.module';

@NgModule({
    imports: [
        AddClassOnHoverModule,
        CommonModule,
        IfOnDomModule,
        MatButtonModule,
        MatIconModule,
        MatMenuModule,
        ModalModule,
        RouterModule,
        JumbotronModule,
        ButtonModule,
    ],
    exports: [
        FeatureBillPayComponent,
        FeatureBudgetsComponent,
        FeatureChargesComponent,
        FeaturePaymentsComponent,
        FeatureTransactionsComponent,
        UnitListFeatureComponent,
    ],
    declarations: [
        FeatureBillPayComponent,
        FeatureBudgetsComponent,
        FeatureChargesComponent,
        FeaturePaymentsComponent,
        FeatureTransactionsComponent,
        UnitListFeatureComponent,
    ],
    providers: [
        ChargesService,
    ],
})
export class FeaturePageModule
{
}
